import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Button,
  Alert,
} from '@mui/material';
import baseURL from '../../config';

const StripSubscription = () => {
  const { id: vesselOwnerId } = useParams();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const res = await axios.get(
          `${baseURL}/api/vesselowner-subscription/getSubscriptionDetails/${vesselOwnerId}`
        );
        setSubscription(res.data);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || 'Failed to fetch subscription data');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [vesselOwnerId]);

  const handleCheckout = async () => {
    if (!subscription) return;

    setCheckoutLoading(true);
    try {
      const res = await axios.post(`${baseURL}/api/vesselowner-subscription/createCheckoutSession`, {
        subscriptionId: subscription._id,
        email: subscription.email,
        vesselOwnerId,
      });

      if (res.data.url) {
        window.location.href = res.data.url; 
      } else {
        setError('Stripe session URL not received.');
      }
    } catch (err) {
      console.error('Checkout error:', err);
      setError(err.response?.data?.message || 'Checkout failed.');
    } finally {
      setCheckoutLoading(false);
    }
  };

  if (loading) {
    return (
      <Box mt={4} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={4}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box maxWidth="sm" mx="auto" mt={6}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold" align="center">
          Stripe Subscription Payment
        </Typography>

        <Typography><strong>Email:</strong> {subscription.email}</Typography>
        <Typography><strong>Vessel Count:</strong> {subscription.vesselCount}</Typography>
        <Typography><strong>Billing Cycle:</strong> {subscription.billingCycle}</Typography>
        <Typography><strong>Amount:</strong> $ {subscription.priceInCents / 100}</Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 4 }}
          onClick={handleCheckout}
          disabled={checkoutLoading}
        >
          {checkoutLoading ? 'Redirecting...' : 'Proceed to Payment'}
        </Button>
      </Paper>
    </Box>
  );
};

export default StripSubscription;
